export default __webpack_public_path__ + "15b08e7a.jpg";